import useTranslation from "@/hooks/useTranslation";
import { useYoudao } from "@/hooks/useTranslator";
import { currentUserState } from "@/stores/common";
import { pubmedState } from "@/stores/pubmed";
import { IconButton } from "@material-ui/core";
import GTranslateOutlinedIcon from "@material-ui/icons/GTranslateOutlined";
import React from "react";
import { useRecoilValue } from "recoil";

interface IProps {
  ids: string[];
}

const TranslateAllButton: React.FC<IProps> = ({ ids }) => {
  const { i18n } = useTranslation();
  const { loading, setAllYoudao, removeAllYoudao } = useYoudao();
  const { translator } = useRecoilValue(pubmedState);
  const currentUser = useRecoilValue(currentUserState);

  const handleClick = () => {
    if (ids.every((id) => translator[id])) {
      removeAllYoudao(ids);
    } else {
      setAllYoudao(ids);
    }
  };

  if (i18n.language !== "en" && currentUser?.id) {
    return (
      <IconButton color="primary" onClick={handleClick} disabled={loading}>
        <GTranslateOutlinedIcon />
      </IconButton>
    );
  }
  return <React.Fragment />;
};

export default TranslateAllButton;
